import tinymce from "tinymce/tinymce.js";
import "tinymce/themes/silver/theme.js";
import "tinymce/skins/ui/oxide/content.css";
import "tinymce/skins/ui/oxide/skin.css";
import "tinymce/plugins/code/plugin.js";
import "tinymce/plugins/image/plugin.js";
import "tinymce/plugins/link/plugin.js";
import "tinymce/plugins/table/plugin.js";
import "tinymce/plugins/anchor/plugin.js";
import "tinymce/plugins/autolink/plugin.js";
import "tinymce/plugins/fullpage/plugin.js";
import "tinymce/plugins/fullscreen/plugin.js";
import "tinymce/plugins/help/plugin.js";
import "tinymce/plugins/hr/plugin.js";
import "tinymce/plugins/insertdatetime/plugin.js";
import "tinymce/plugins/lists/plugin.js";
import "tinymce/plugins/nonbreaking/plugin.js";
import "tinymce/plugins/paste/plugin.js";
import "tinymce/plugins/preview/plugin.js";
import "tinymce/plugins/searchreplace/plugin.js";
import "tinymce/plugins/wordcount/plugin.js";
import "tinymce/plugins/imagetools/plugin.js";
import "tinymce/icons/default/icons.js"


import "./sv_SE.js";
import { store } from "../../store/configureStore";
export default tinymce;
function getLanguageCodeForTiny() {
  let state = store.getState();
  let cms = state.cms;
  if (cms && cms.languageCode) {
    if (cms.languageCode == "swe") {
      return "sv_SE";
    } else if (cms.languageCode == "eng") {
      return "en_GB";
    }
  }
  return undefined;
}

export const classicSettings = {
  plugins: "link image code table autoresize anchor autolink fullpage fullscreen help hr insertdatetime lists nonbreaking paste preview searchreplace wordcount image imagetools",
  toolbar:
    "code | undo redo | bold italic | forecolor backcolor | alignleft aligncenter alignright | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol" +
    " | anchor | fullpage | fullscreen | help | hr | image | insertdatetime | fontsizeselect | numlist bullist | nonbreaking | paste | preview | searchreplace | archive",
  language: getLanguageCodeForTiny(),
  language_url: "../../components/TinyMCE/sv_SE.js",
  height: "70vh",
  fontsize_formats: "8px 10px 12px 14px 18px 24px 36px",
  content_style: undefined,
  imagetools_toolbar: "editimage imageoptions | alignleft aligncenter alignright",
  imagetools_cors_hosts: ["jirango.blob.core.windows.net"],
  imagetools_credentials_hosts: ["jirango.blob.core.windows.net"],
  fullpage_default_doctype: "<!DOCTYPE html>",
  fullpage_default_encoding: "UTF-8",
  link_assume_external_targets: "https",
  relative_urls: false,
  remove_script_host: false,
  convert_urls: false,
};
export const classicSettings2 = {
  plugins: "link image code table anchor autolink help hr insertdatetime lists nonbreaking paste preview searchreplace wordcount image imagetools",
  toolbar:
    "code | undo redo | bold italic | forecolor backcolor | alignleft aligncenter alignright | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol" +
    " | anchor | fullpage | fullscreen | help | hr | image | insertdatetime | fontsizeselect |  numlist bullist | nonbreaking | paste | preview | searchreplace | archive",
  language: getLanguageCodeForTiny(),
  language_url: "../../components/TinyMCE/sv_SE.js",
  height: "70vh",
  fontsize_formats: "8px 10px 12px 14px 18px 24px 36px",
  content_style: undefined,
  imagetools_toolbar: "editimage imageoptions | alignleft aligncenter alignright",
  imagetools_cors_hosts: ["jirango.blob.core.windows.net"],
  imagetools_credentials_hosts: ["jirango.blob.core.windows.net"],
  fullpage_default_doctype: "<!DOCTYPE html>",
  fullpage_default_encoding: "UTF-8",
  link_assume_external_targets: "https",
  relative_urls: false,
  remove_script_host: false,
  convert_urls: false,
};
export const inlineSettings2 = {
  menubar: false,
  plugins: "link code table paste lists nonbreaking preview ",
  paste_as_text: true,
  toolbar: "code | undo redo | styleselect bold italic underline | link | fontsizeselect |  forecolor backcolor | alignleft aligncenter alignright | table tabledelete pastetext |  hr  | numlist bullist | preview  ",
  language: getLanguageCodeForTiny(),
  language_url: "../../components/TinyMCE/sv_SE.js",
  height: "300px",
  fontsize_formats: "8px 10px 12px 14px 18px 24px 36px",
  content_style: undefined,
  inline: true,
  imagetools_toolbar: "editimage imageoptions | alignleft aligncenter alignright",
  imagetools_cors_hosts: ["jirango.blob.core.windows.net"],
  imagetools_credentials_hosts: ["jirango.blob.core.windows.net"],
  fullpage_default_doctype: "<!DOCTYPE html>",
  fullpage_default_encoding: "UTF-8",
  link_assume_external_targets: "https",
  relative_urls: false,
  remove_script_host: true,
  convert_urls: false,
};

export const inlineSettings = {
  menubar: false,
  plugins: "link code table paste",
  paste_as_text: true,
  toolbar: "code | undo redo | styleselect   bold italic underline  | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright | table tabledelete pastetext" + "   | archive | anchor",
  language: getLanguageCodeForTiny(),
  fontsize_formats: "8px 10px 12px 14px 18px 24px 36px",
  language_url: "../../components/TinyMCE/sv_SE.js",
  content_style: undefined,
  imagetools_toolbar: "editimage imageoptions | alignleft aligncenter alignright",
  imagetools_cors_hosts: ["jirango.blob.core.windows.net"],
  imagetools_credentials_hosts: ["jirango.blob.core.windows.net"],
  theme_advanced_toolbar_location: "bottom",
  theme_advanced_toolbar_align: "bottom",
  theme_advanced_statusbar_location: "bottom",
  block_formats: "Headline=h1;Paragraph=p;",
  theme_advanced_resizing: true,
  theme_advanced_toolbar_location: "bottom",
  inline: true,
  fullpage_default_doctype: "<!DOCTYPE html>",
  fullpage_default_encoding: "UTF-8",
  /*  width: 'auto', */
  link_assume_external_targets: "https",
  relative_urls: false,
  remove_script_host: true,
  convert_urls: false,
};

export const tabSettings = {
  menubar: false,
  plugins: "link code table anchor autolink fullscreen format  hr insertdatetime lists nonbreaking paste preview visualblocks searchreplace wordcount media image imagetools",
  toolbar: "styleselect   bold italic underline |link | fontsizeselect |  numlist bullist | forecolor backcolor " + "   | archive",
  language: getLanguageCodeForTiny(),
  language_url: "../../components/TinyMCE/sv_SE.js",
  content_style: undefined,
  fontsize_formats: "8px 10px 12px 14px 18px 24px 36px",
  imagetools_toolbar: "editimage imageoptions | alignleft aligncenter alignright",
  imagetools_cors_hosts: ["jirango.blob.core.windows.net"],
  imagetools_credentials_hosts: ["jirango.blob.core.windows.net"],
  theme_advanced_toolbar_location: "bottom",
  theme_advanced_toolbar_align: "bottom",
  theme_advanced_statusbar_location: "bottom",
  block_formats: "Headline=h1;Paragraph=p;",
  theme_advanced_resizing: true,
  theme_advanced_toolbar_location: "bottom",
  inline: false,
  fullpage_default_doctype: "<!DOCTYPE html>",
  fullpage_default_encoding: "UTF-8",
  /*  width: 'auto', */
  link_assume_external_targets: "https",
  relative_urls: false,
  remove_script_host: true,
  convert_urls: false,
};
